<template>
  <div class="radio_container">
    <ul class="circle_radio">
      <li v-for="item in termProps" :key="item.id">
        <input v-model="selectedTermProps.type" type="radio" :id="item.id" :name="item.id" :value="item.type">
        <label :for="item.id" class="pointer" :class="item.type === selectedTermProps.type ? 'txt_subtitle_1' : 'txt_body_1'">
          <span></span>{{ item.trans }}</label>
        <div
            v-if="item.sale"
            class="save txt_button_1 --success20"
        >
          {{ item.sale }}
        </div>
      </li>
    </ul>
    <span class="txt_body_2 --grey60">
      * Not include VAT
    </span>
  </div>
</template>
<script>
export default {
  name: 'PaymentTypeRadio',
  props: {
    termProps: Array,
    selectedTermProps: Object
  }
}
</script>